module.exports = __webpack_public_path__ + "static/media/yashindustry-banner.8ae69187.png";